<template>
  <div class="layout-content-list">
    <div class="btn-group-box clearfix">
      <div class="fl">{{ getName }}列表</div>
      <div class="fr" id="auto-0">
        <el-button type="primary" plain @click="goToAdd"
          ><span class="btn-group-inner"
            ><i class="font-size14 iconfont iconjia" style="margin-bottom: 3px"></i>新增{{ getName }}</span
          ></el-button
        >
      </div>
    </div>
    <div class="table-custom-box" id="auto-1">
      <el-table :data="tableData.list" border style="width: 100%">
        <el-table-column prop="plateNumber" label="车牌号" min-width="180"> </el-table-column>
        <el-table-column prop="operator" label="操作人" min-width="180"> </el-table-column>
        <el-table-column prop="createTime" label="新增日期" min-width="180"> </el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <div>
              <el-button type="text" @click="handleRomoveList(scope.row)">移出{{ getName }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:1
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI, vali } from '@/api/common';
import axiosNew from '@/api/axiosNew';
import api from '@/api/logistics.api';
import listMap from '@/views/logistics/listMap';

export default {
  props: {
    type: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      companyCode: WUYI.currentData.company.companycode,
      tableData: {
        list: []
      }
    };
  },
  computed: {
    getName() {
      return listMap && listMap[this.type].name;
    }
  },
  created() {
    this.getPlateList();
  },
  methods: {
    getPlateList() {
      axiosNew
        .post(api.billmanagerListVehicle, {
          companyCode: this.companyCode,
          companyListType: listMap[this.type].apiTypeVal
        })
        .then(res => {
          this.tableData.list = res.data.vehicleList || [];
        });
    },
    goToAdd() {
      this.$router.push({
        name: listMap[this.type].addPathName,
        params: { type: 'plate' }
      });
    },
    handleRomoveList(row) {
      this.$confirm(`是否确定移出${listMap[this.type].name}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          axiosNew
            .post(api.billmanagerDelete, {
              ids: row.id.toString()
            })
            .then(res => {
              this.getPlateList();
            });
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped>
.btn-group-box {
  margin-top: 0;
}
</style>
